



























import {Component, Vue, Prop} from "vue-property-decorator";
import {namespace} from "vuex-class";

import IFlagRu from '@/components/icons/IFlagRu.vue'
import IFlagEn from '@/components/icons/IFlagEn.vue'
import IFlagDe from '@/components/icons/IFlagDe.vue'

const locale = namespace('locale')
const profile = namespace('profile')
const roistat = namespace('roistat')
const resources = namespace('resources')


@Component({
  components:{
    'i-flag-ru':IFlagRu,
    'i-flag-en':IFlagEn,
    'i-flag-de':IFlagDe,
  }
})
export default class SelectLocale extends Vue {
  @Prop({type: [Boolean], default: true}) protected isText!: boolean

  @locale.Getter('getLocale') protected getLocale:any
  @locale.Mutation('updateLocale') protected updateLocale:any
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  @resources.Action('getCountryFromServerHard') protected getCountryFromServerHard:any

  public get lang(): any {
    return this.getLocale
  }
  public set lang(lang: any) {
    this.updateLocale(lang)
    this.getCountryFromServerHard()
    if(lang != 'ru') {
      let params = [
        {
          "name": "Переключение языка на " + (lang == 'en' ? "“English”" : "“Deutch”"),
          "data": {
            "company": this.userCompany.title
          }
        }
      ]
      this.sendEvent(params)
    }
  }
}



